<template>
  <div>
    <div v-if="loadingStatus">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="ma-2"
          type="card@2"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <v-sheet v-else elevation="2" color="#57bc90" style="min-height: 70vh">
      <v-col
        cols="12"
        md="10"
        sm="10"
        class="mx-auto"
        v-for="article in displayedNews"
        :key="article._id"
      >
        <base-title-bar
          elevation="2"
          class="text-center"
          color="#17408B"
          :label="`${article.Title}`"
          icon="mdi-baseball-bat"
          height="50"
          textProp="pt-2 text-subtitle-1 white--text"
        />

        <!--//* goalies cards.. -->
        <v-card class="mx-auto" rounded elevation="2">
          <v-card-text>
            <span class="caption">
              {{ article.Updated | dayFormat }}
            </span>
            <p class="overline">{{ article.Categories }}</p>
            <p>{{ article.Content }}</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="shouldShowViewMore"
        cols="12"
        md="10"
        sm="10"
        class="mx-auto text-center pb-4"
      >
        <v-btn
          color="green darken-1"
          dark
          @click="showSubscriptionModal = true"
        >
          View More
        </v-btn>
      </v-col>
    </v-sheet>

    <news-subscription-modal
      :showModal="showSubscriptionModal"
      @close="showSubscriptionModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NewsSubscriptionModal from "@/components/Modal/NewsSubscriptionModal.vue";

export default {
  name: "MlbNewsComponent",

  components: {
    NewsSubscriptionModal,
  },

  props: {
    news: {
      type: [Array, Object],
      required: true,
    },
    Position: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      showSubscriptionModal: false,
    };
  },

  computed: {
    ...mapState("MlbModule", ["loadingStatus"]),
    ...mapState("userModule", ["userState"]),

    planType() {
      return this.userState?.plantype || localStorage.getItem("planType") || "";
    },

    isFreeUser() {
      return this.planType === "Free" || this.planType === "";
    },

    displayedNews() {
      if (!this.news) return [];

      const newsArray = Array.isArray(this.news) ? this.news : [this.news];

      if (this.isFreeUser) {
        return newsArray.slice(0, 5);
      }
      return newsArray;
    },

    shouldShowViewMore() {
      const newsArray = Array.isArray(this.news) ? this.news : [this.news];
      return this.isFreeUser && newsArray.length > 5;
    },
  },
};
</script>

<style></style>
